module.exports = __webpack_public_path__ + "img/204.5801b151.jpg";